<template>
	<div>
		<div v-for="(item,index) in couponsStyle" :key="index" class="discount" v-if="index < 3">
      <div v-if="couponsPlatform == 'DD' || couponsPlatform == 'WPH'">
        <div class="cutAcross" v-if="item.category == 3">
          领劵 | {{item.privilege}}
        </div>
        <div class="storeCoupon" v-if="item.category == 6">
          满N件折 | {{item.privilege}}
        </div>
        <div class="storeCoupon" v-if="item.category == 10">
          满1件折 | {{item.privilege}}
        </div>
        <div class="ticketCoupon" v-if="item.category == 7 ">
          店铺促销 | {{item.privilege}}
        </div>
        <div class="redPro" v-if="item.category == 8">
          满额减 | {{item.privilege}}
        </div>
        <div class="grayShop" v-if="item.couponsType == 4 || item.category == ''">
          自定义 | {{item.privilege}}
        </div>
      </div>
      <div v-if="couponsPlatform != 'DD' && couponsPlatform != 'WPH'">
        <div v-if="item.couponsType == 1">
          <div class="ticketCoupon" v-if="item.category == 1">
            淘客券 | {{item.privilege}}
          </div>
          <div class="cutAcross" v-if="item.category == 2 || item.category == '' || !item.category">
            店铺优惠券 | {{item.privilege}}
          </div>
          <div class="goodsCoupon" v-if="item.category == 3">
            商品优惠券 | {{item.privilege}}
          </div>
          <div class="categoryShoppingCoupon" v-if="item.category == 4">
            品类购物券 | {{item.privilege}}
          </div>
          <div class="grayShop" v-if="item.category == 5">
            关注店铺券 | {{item.privilege}}
          </div>
          <div class="redPro" v-if="item.category == 9">
            店铺活动券 | {{item.privilege}}
          </div>
        </div>
        <div v-if="item.couponsType == 2" class="redPro">
          店铺活动 | {{item.privilege}}
        </div>
        <div v-if="item.couponsType == 3" class="sellPurple">
          预售 | {{item.privilege}}
        </div>
        <div v-if="item.couponsType == 4" class="grayShop">
          自定义 | {{item.privilege}}
        </div>
        <div v-if="item.couponsType == 5" class="storeCoupon">
          跨店满减 | {{item.privilege}}
        </div>
        <div v-if="item.couponsType == 6" class="redPro">
          官方立减 | {{item.privilege}}
        </div>
      </div>
    </div>
    <!-- 优惠券超出部分 -->
    <el-popover placement="top" width="320" trigger="hover">
      <div style="max-height: 240px;overflow:auto;">
        <div v-for="(item,index) in couponsStyle" :key="index" style="text-align: center;font-size: 12px; color: white;margin-bottom: 7px;line-height: 20px;float: left;margin-right: 20px;">
          <div v-if="couponsPlatform == 'DD' || couponsPlatform == 'WPH'">
            <div class="cutAcross" v-if="item.category == 3">
              领劵 | {{item.privilege}}
            </div>
            <div class="storeCoupon" v-if="item.category == 6">
              满N件折 | {{item.privilege}}
            </div>
            <div class="storeCoupon" v-if="item.category == 10">
              满1件折 | {{item.privilege}}
            </div>
            <div class="ticketCoupon" v-if="item.category == 7 ">
              店铺促销 | {{item.privilege}}
            </div>
            <div class="redPro" v-if="item.category == 8">
              满额减 | {{item.privilege}}
            </div>
            <div class="grayShop" v-if="item.couponsType == 4">
              自定义 | {{item.privilege}}
            </div>
            <div class="redPro" v-if="item.category == 9">
              店铺活动券 | {{item.privilege}}
            </div>
          </div>
          <div v-if="couponsPlatform != 'DD' && couponsPlatform != 'WPH'">
            <div v-if="item.couponsType == 1">
              <div class="ticketCoupon" v-if="item.category == 1">
                淘客券 | {{item.privilege}}
              </div>
              <div class="cutAcross" v-if="item.category == 2 || item.category == '' || !item.category">
                店铺优惠券 | {{item.privilege}}
              </div>
              <div class="goodsCoupon" v-if="item.category == 3">
                商品优惠券 | {{item.privilege}}
              </div>
              <div class="categoryShoppingCoupon" v-if="item.category == 4">
                品类购物券 | {{item.privilege}}
              </div>
              <div class="grayShop"  v-if="item.category == 5">
                关注店铺券 | {{item.privilege}}
              </div>
            </div>
            <div v-if="item.couponsType == 2" class="redPro">
              店铺活动 | {{item.privilege}}
            </div>
            <div v-if="item.couponsType == 3" class="sellPurple">
              预售 | {{item.privilege}}
            </div>
            <div v-if="item.couponsType == 4" class="grayShop">
              自定义 | {{item.privilege}}
            </div>
            <div v-if="item.couponsType == 5" class="storeCoupon">
              跨店满减 | {{item.privilege}}
            </div>
            <div v-if="item.couponsType == 6" class="redPro">
              官方立减 | {{item.privilege}}
            </div>
          </div>
        </div>
      </div>
      <i class="el-icon-more" slot="reference" style="margin-top: 40px;margin-left: 40px;" v-show="couponsStyle && couponsStyle.length > 3"></i>
    </el-popover>
	</div>
</template>
<script>
export default {
	name:'couponsStyle',
	props:["couponsStyle","couponsPlatform"],
}
</script>
<style lang="scss" scoped>
 .discount {
    text-align: center;
    font-size: 12px;
    color: white;
    margin-bottom: 7px;
    line-height: 20px;
    float: left;
    clear: both;
  }
</style>